module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAICAYAAACYhf2vAAAABHNCSVQICAgIfAhkiAAAAHBJREFUOE/Nk0ENgDAMRV8VgBQckDlAwhyABHCCAxzA5ggUlBQIN45L6bGHvqb9TwB0ix3QAw1QW69wJWCSMCd54Eth4Nf4ILrGhNC6LKBku4C6wG/o7ruAcvziBWaAXwhfDZXh0lCoimdCyQijaXgC6HInmSupTvAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bar_chart_yellow_label.png
// module id = uSmi
// module chunks = 3